import React from 'react';
import { IconButton } from 'components/common';
import { FaArrowLeft, FaDownload, FaList } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types'

const WaiverHeaderPrint = ({ download }) => {
  const navigate = useNavigate()

  const handleWaiverList = () => {
    navigate("/crm/projects/waivers")
  }

  const handlePrintToPDF = () => {
    download()
  }

  return (
    <div className="tw-bg-white tw-rounded tw-border tw-border-solid tw-border-slate-200 tw-shadow-sm tw-mb-3">
      <div className="tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center">
        <IconButton
          icon={<FaArrowLeft size={12} />}
          variant="secondary"
          size="sm"
          onClick={() => navigate(-1)}
        />
        <div className="tw-flex tw-items-center tw-gap-1">
          <IconButton
            icon={<FaDownload size={12} />}
            variant="secondary"
            size="sm"
            className="tw-hidden sm:tw-inline-flex tw-mr-1"
            onClick={handlePrintToPDF}
          >
            <span className="tw-hidden xl:tw-inline-block tw-ml-1">
              Download
            </span>
          </IconButton>

          <IconButton
            icon={<FaList size={12} />}
            variant="secondary"
            size="sm"
            className="tw-hidden sm:tw-inline-flex tw-mr-1"
            onClick={handleWaiverList}
          >
            <span className="tw-hidden xl:tw-inline-block tw-ml-1">
              Back to Waiver
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
}

WaiverHeaderPrint.propTypes = {
  download: PropTypes.func
}

export default WaiverHeaderPrint
